/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import PageHeader from "components/common/PageHeader";
import SearchOnEnterInput from "components/SearchOnEnterInput";
import PageSection from "components/PageSection";
import { pageSectionCss, searchInputCss } from "./index.css";
import { gap32Css } from "../profile/EditForm/index.css";

export default function Layout({ children, title }) {
  return (
    <div className="container">
      <PageHeader title={title} />
      <PageSection css={[pageSectionCss, gap32Css]} className="flex-a-c-j-sb ">
        <SearchOnEnterInput css={searchInputCss} />
        <SearchOnEnterInput css={searchInputCss} paramKey="keywords" />
      </PageSection>
      {children}
    </div>
  );
}

Layout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
